import Chip from '@mui/material/Chip';

export default Chip;
